var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.optLoading,
          expression: "optLoading",
        },
      ],
      staticClass: "view-contanier",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.typeList, function (item, $index) {
            return _c(
              "span",
              {
                key: item.$index,
                class: ["tabItem", _vm.typeActive === $index ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.changeType($index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item, $index) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: item.permissson,
                class: ["tabItem", _vm.active === $index ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.changeTabType($index, item.permissson)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.name) +
                    " (" +
                    _vm._s(
                      item.type === 10000
                        ? _vm.tabTotal
                        : _vm.tabNumer.find((a) => a.type === item.type)?.qty ||
                            0
                    ) +
                    ") "
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.derivePre,
                    expression: "derivePre",
                  },
                ],
                staticClass: "derive flex_c_c",
                attrs: { "v-permissson": _vm.derivePre },
                on: { click: _vm.derive },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/const/derive.png"),
                    alt: "导出",
                  },
                }),
                _vm._v(" 导出 "),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "add",
                    expression: "'add'",
                  },
                ],
                staticClass: "btn flex_c_c",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible6 = true
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/const/add.png") },
                }),
                _vm._v(" 上传水单 "),
              ]
            ),
            _vm.filterList.date && _vm.isActive
              ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                  _vm._v(
                    " 查询时间：" +
                      _vm._s(
                        _vm.filterList.date[0] + "~" + _vm.filterList.date[1]
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c(
              "BaseFilter",
              {
                attrs: { isActive: _vm.isActive, width: 466 },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: { model: _vm.filterList, "label-width": "70px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "上传日期" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                align: "center",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                "unlink-panels": "",
                                "picker-options": _vm.pickerOptions,
                              },
                              model: {
                                value: _vm.filterList.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterList, "date", $$v)
                                },
                                expression: "filterList.date",
                              },
                            }),
                          ],
                          1
                        ),
                        !_vm.typeActive
                          ? [
                              _c(
                                "el-form-item",
                                { attrs: { label: "客户" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "320px" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择客户",
                                      },
                                      model: {
                                        value: _vm.filterList.companyId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "companyId",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.companyId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.companyDrapdown,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c(
                                "el-form-item",
                                { attrs: { label: "供应商" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "320px" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择供应商",
                                      },
                                      model: {
                                        value: _vm.filterList.supplierId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "supplierId",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.supplierId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.supplierOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                        _c(
                          "el-form-item",
                          { attrs: { label: "上传方式" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "请选择上传方式",
                                },
                                model: {
                                  value: _vm.filterList.uploadType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "uploadType", $$v)
                                  },
                                  expression: "filterList.uploadType",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: 0,
                                  attrs: { label: "核销", value: 0 },
                                }),
                                _c("el-option", {
                                  key: 1,
                                  attrs: { label: "预充值", value: 1 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择银行",
                                },
                                model: {
                                  value: _vm.filterList.bankName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "bankName", $$v)
                                  },
                                  expression: "filterList.bankName",
                                },
                              },
                              _vm._l(_vm.bankNameOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "银行账号" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "请输入银行账号" },
                              model: {
                                value: _vm.filterList.bankAccountNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.filterList,
                                    "bankAccountNumber",
                                    $$v
                                  )
                                },
                                expression: "filterList.bankAccountNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "水单编号" } },
                          [
                            _c("base-muti-input", {
                              ref: "baseMutiInput",
                              staticStyle: { width: "320px" },
                              model: {
                                value: _vm.filterList.id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterList, "id", $$v)
                                },
                                expression: "filterList.id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                key: _vm.active,
                ref: "baseTable",
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  pageSizes: [20, 30, 50, 100],
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  handleSelectionChange: _vm.handleSelectionChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "id",
                      fn: function (row) {
                        return [
                          row.scope.hasNewNotice
                            ? _c("img", {
                                staticClass: "hasNewNotice",
                                attrs: {
                                  src: require("@/assets/images/const/newNotice.png"),
                                },
                              })
                            : _vm._e(),
                          _c(
                            "span",
                            { staticStyle: { color: "rgb(18, 88, 188)" } },
                            [
                              _vm._v(" " + _vm._s(row.scope.id) + " "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "permissson",
                                    rawName: "v-permissson",
                                    value: _vm.viewWaterBillAuth(),
                                    expression: "viewWaterBillAuth()",
                                  },
                                ],
                                attrs: {
                                  src: require("@/assets/images/const/viewBill.png"),
                                  title: "查看水单",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewWaterBill(
                                      row.scope,
                                      row.scope.status === -2 ? 1 : 0
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "companyId",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatterCompany(row.scope.companyId)
                                ) +
                                " "
                            ),
                            _c("img", {
                              directives: [
                                {
                                  name: "permissson",
                                  rawName: "v-permissson",
                                  value: _vm.editAuth(),
                                  expression: "editAuth()",
                                },
                              ],
                              attrs: {
                                src: require("@/assets/images/const/edit.png"),
                                title: "处理记录",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit(row.scope)
                                },
                              },
                            }),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "supplierId",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formattersupplier(row.scope.supplierId)
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "currentAmount",
                      fn: function (row) {
                        return [
                          _c("p", { staticClass: "const" }, [
                            _vm._v("余额:$ " + _vm._s(row.scope.currentAmount)),
                          ]),
                          !_vm.typeActive
                            ? _c("p", { staticClass: "const" }, [
                                _vm._v(
                                  "额度:$ " + _vm._s(row.scope.creditAmount)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "status",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag",
                              style: _vm.styleStatus(row.scope.status),
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatterStatus")(row.scope.status)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "bankAccountNumber",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticClass: "label",
                                staticStyle: { width: "40px" },
                              },
                              [_vm._v("银行")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.bankName)),
                            ]),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticClass: "label",
                                staticStyle: { width: "40px" },
                              },
                              [_vm._v("账号")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.bankAccountNumber)),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "createdOn",
                      fn: function (row) {
                        return [
                          row.scope.createdOn
                            ? [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("上传人")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(row.scope.createdName)),
                                  ]),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("上传时间")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatterTime")(
                                          row.scope.createdOn
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            : [_c("span", { staticClass: "empty" })],
                        ]
                      },
                    },
                    {
                      key: "verificationOn",
                      fn: function (row) {
                        return [
                          row.scope.verificationOn
                            ? [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("审核人")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(row.scope.verificationName)),
                                  ]),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("审核时间")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatterTime")(
                                          row.scope.verificationOn
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            : [_c("span", { staticClass: "empty" })],
                        ]
                      },
                    },
                    {
                      key: "receiptOn",
                      fn: function (row) {
                        return [
                          row.scope.verificationOn
                            ? [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("到账人")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(row.scope.receiptName)),
                                  ]),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("到账时间")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatterTime")(
                                          row.scope.receiptOn
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            : [_c("span", { staticClass: "empty" })],
                        ]
                      },
                    },
                    {
                      key: "returnOn",
                      fn: function (row) {
                        return [
                          row.scope.verificationOn
                            ? [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("退回人")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(row.scope.returnName)),
                                  ]),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "label",
                                      staticStyle: { width: "60px" },
                                    },
                                    [_vm._v("退回时间")]
                                  ),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatterTime")(
                                          row.scope.returnOn
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            : [_c("span", { staticClass: "empty" })],
                        ]
                      },
                    },
                    {
                      key: "sourceAmount",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(row.scope.sourceAmount || 0) +
                                " " +
                                _vm._s(row.scope.sourceCurrency)
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "receivedAmount",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(row.scope.receivedAmount || 0) +
                                " " +
                                _vm._s(row.scope.realCurrency)
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "handAmount",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(row.scope.handAmount || 0) +
                                " " +
                                _vm._s(row.scope.realCurrency)
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "sourceAmount2",
                      fn: function (row) {
                        return [
                          row.scope.status === -2
                            ? [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.scope.receivedAmount || 0) +
                                      " " +
                                      _vm._s(row.scope.realCurrency)
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "verifedAmount",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " + _vm._s(row.scope.verifedAmount || 0) + " "
                          ),
                          +row.scope.verifedAmount > 0
                            ? _c("i", {
                                staticClass: "el-icon-link",
                                staticStyle: { color: "rgb(18, 88, 188)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showVerifedLog(row.scope)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "table-opt" },
                                [
                                  _vm.active === 0
                                    ? [
                                        row.scope.status === 0
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "permissson",
                                                    rawName: "v-permissson",
                                                    value: "check_0",
                                                    expression: "'check_0'",
                                                  },
                                                ],
                                                staticClass: "opt-item",
                                                attrs: { title: "审核" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.check(row.scope)
                                                  },
                                                },
                                              },
                                              [_vm._v("审核")]
                                            )
                                          : _vm._e(),
                                        row.scope.status === 1
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "permissson",
                                                    rawName: "v-permissson",
                                                    value: "credited_0",
                                                    expression: "'credited_0'",
                                                  },
                                                ],
                                                staticClass: "opt-item",
                                                attrs: { title: "到账" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.arrive(row.scope)
                                                  },
                                                },
                                              },
                                              [_vm._v("到账")]
                                            )
                                          : _vm._e(),
                                        row.scope.status === 2
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "permissson",
                                                    rawName: "v-permissson",
                                                    value: "back_0",
                                                    expression: "'back_0'",
                                                  },
                                                ],
                                                staticClass: "opt-item",
                                                attrs: { title: "退回" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.back(row.scope)
                                                  },
                                                },
                                              },
                                              [_vm._v("退回")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "viewLog_0",
                                                expression: "'viewLog_0'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "处理记录" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewLog(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("处理记录")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.active === 1
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "check",
                                                expression: "'check'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "审核" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.check(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("审核")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "viewLog_a",
                                                expression: "'viewLog_a'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "处理记录" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewLog(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("处理记录")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.active === 2
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "credited",
                                                expression: "'credited'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "到账" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.arrive(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("到账")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "viewLog_b",
                                                expression: "'viewLog_b'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "处理记录" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewLog(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("处理记录")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.active === 3
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "back",
                                                expression: "'back'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "退回" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.back(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("退回")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "viewLog_c",
                                                expression: "'viewLog_c'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "处理记录" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewLog(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("处理记录")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.active === 4
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "viewLog_d",
                                                expression: "'viewLog_d'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            attrs: { title: "处理记录" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewLog(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("处理记录")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "custom-total",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-total" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("div", { staticClass: "select" }, [
                                _vm._v(
                                  "已选 " +
                                    _vm._s(_vm.selectionItem.length) +
                                    " 项"
                                ),
                              ]),
                              _vm.selectionItem.length
                                ? _c("div", {
                                    staticClass: "total",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.totalHtml),
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  604031842
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("wait-check-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          rowData: _vm.editData,
          typeActive: _vm.typeActive,
        },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("arrive-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          editData: _vm.editData,
          companyList: _vm.companyList,
          typeActive: _vm.typeActive,
        },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
      _c("view-water-bill-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          type: _vm.type,
          rowData: _vm.editData,
          typeActive: _vm.typeActive,
        },
        on: { cancel: _vm.cancel3 },
      }),
      _c("back-water-bill-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible4,
          editData: _vm.editData,
          companyList: _vm.companyList,
          typeActive: _vm.typeActive,
        },
        on: { ok: _vm.ok4, cancel: _vm.cancel4 },
      }),
      _c("water-bill-log-drawer", {
        attrs: {
          drawer: _vm.drawer,
          billId: _vm.editData.id,
          typeActive: _vm.typeActive,
        },
        on: { close: _vm.close },
      }),
      _c("AccountDialog", {
        attrs: {
          dialogFormVisible: _vm.dialogVisible5,
          editData: _vm.editData,
          typeActive: _vm.typeActive,
        },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("UpdateWaterOrderDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible6,
          typeActive: _vm.typeActive,
          supplierOptions: _vm.supplierOptions,
        },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible6 = false
          },
        },
      }),
      _c("VerifedLogByWaterBillDrawer", {
        attrs: {
          drawer: _vm.drawer1,
          rowData: _vm.editData,
          typeActive: +_vm.typeActive,
        },
        on: {
          close: function ($event) {
            _vm.drawer1 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }